import { CssBaseline, ThemeProvider } from "@mui/material";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Routes } from "./Routes";
import { createExtraordinaryTheme } from "./utils/theme";
import { useConfig } from "./utils/useConfig";

function App() {
  const extraordinaryTheme = createExtraordinaryTheme();
  const { config } = useConfig();

  return (
    <ThemeProvider theme={extraordinaryTheme}>
      <CssBaseline />
      <GoogleReCaptchaProvider
        reCaptchaKey={config?.GOOGLE_RECAPTCHA_SITE_KEY ?? ""}
      >
        <Routes />
      </GoogleReCaptchaProvider>
    </ThemeProvider>
  );
}

export default App;
